import { Content } from 'antd/es/layout/layout';
import React, { useRef } from 'react';
import { Divider } from 'antd';
import ProductCard from './shop-front-component/ProductCard';
import { leftPanels } from './shop-front-component/ProductCollection';
import { useNavigate } from 'react-router-dom';
import PAQ from './shop-front-component/PAQ';
import { CFCDN } from './shop-front-component/ProductCollection';
import ShopFrontFooter from './shop-front-component/ShopFrontFooter';
import ShopFrontHeaderSticky from './shop-front-component/ShopFrontHeaderSticky';
import SmallHeaderSticky from './shop-front-component/SmallHeaderSticky';
import { useIsVisible } from './shop-front-component/useIsVisible';
import ModalAuth from 'modules/auth/modal-auth/ModalAuth';

export default function ShopFront() {
  const navigate = useNavigate();
  const ref1 = useRef<HTMLDivElement>(null);
  const isVisible1 = useIsVisible(ref1);

  const ref2 = useRef<HTMLDivElement>(null);
  const isVisible2 = useIsVisible(ref2);

  const ref3 = useRef<HTMLDivElement>(null);
  const isVisible3 = useIsVisible(ref3);

  const getDisplayDelay = (index: number) => {
    return String((index + 1) * 300) + 'ms';
  };
  return (
    <div className="hedvig-letters-sans-regular bg-white relative">
      <button
        onClick={() => {
          navigate('/contact');
        }}
        className="group flex flex-row gap-2 items-center fixed bottom-0 right-0 z-50 px-5 py-1 mr-5 mb-5 transform text-black text-xl rounded-md  bg-transparent  hover:bg-neutral-300 transition-transform duration-300 w-fit hover:-translate-y-1 border-none"
      >
        <div className="absolute inset-0 bg-black opacity-10 rounded-md group-hover:opacity-0"></div>
        <div className="w-2.5 h-2.5 bg-green-500 rounded-full mr-2"></div>{' '}
        Contact Us
      </button>
      <ShopFrontHeaderSticky></ShopFrontHeaderSticky>
      <SmallHeaderSticky></SmallHeaderSticky>
      <ModalAuth></ModalAuth>
      <Content className="pt-20 lg:pt-0 flex flex-col  px-2 max-w-screen-2xl mx-auto justify-center items-center">
        <div className=" flex flex-col mt-16 md:mt-40 justify-center items-center w-full">
          <span className="text-black text-[2.5rem] md:text-[4.5rem] hedvig-letters-serif-regular text-center">
            Shading Solutions, Designed <br></br>for You.
          </span>
          <div>
            <Divider style={{ width: '30px' }}></Divider>
          </div>
          <button
            className="transform text-white bg-black text-xl rounded-md  hover:text-black hover:bg-neutral-200 transition-transform duration-300 w-fit p-2 px-3 hover:-translate-y-1 border-none"
            onClick={() => {
              navigate('/order/create');
            }}
          >
            Check your price
          </button>
        </div>
        <div className=" relative flex flex-col justify-center items-center w-full max-w-screen-2xl rounded-md overflow-hidden w-full h-[35rem] xl:h-[40rem] mt-12">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="object-center object-cover  w-full h-full"
            poster={CFCDN + '0902.png'}
          >
            <source src={CFCDN + '0902.mp4'} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </Content>
      <Content className="relative grid grid-cols-1  gap-20 px-2 max-w-screen-2xl mx-auto mt-10 mb-32">
        <div
          ref={ref2}
          className={`max-w-screen-2xl flex flex-col items-center justify-center transition-all duration-700 ease-in ${
            isVisible2 ? 'opacity-100' : 'translate-x-16 opacity-0'
          }`}
        >
          <div className="w-full  h-full items-start gap-3">
            <div className="flex flex-col  m-auto items-center justify-center mt-10 mb-10">
              <span className="text-[2rem] md:text-[3.5rem] text-center  hedvig-letters-serif-regular">
                Outdoor Blinds
              </span>
              <div>
                <Divider style={{ width: '30px' }}></Divider>
              </div>
              <span className="hedvig-letters-sans-regular text-lg  text-center text-neutral-500">
                {
                  'Enhance your outdoor living space with our stylish and durable outdoor blinds, designed to provide shade and protect against wind, rain, and insects.'
                }
              </span>
            </div>

            <div
              className={`w-full overflow-x-scroll w-[95vw] max-w-screen-2xl no-scrollbar ml-2 lg:ml-0`}
            >
              <div className={` flex flex-row gap-5  lg:justify-center`}>
                <div className="w-[30rem] h-[40rem] flex flex-col gap-5 justify-center items-center p-2 rounded-md border border-solid border-neutral-200">
                  <img
                    className="w-[20rem] aspect-square object-cover mx-auto "
                    src={
                      CFCDN +
                      'protecta/Screenshot+2024-05-15+at+17-51-16+Protecta+Awning+Systems.png'
                    }
                    alt="Protecta Zip Awning"
                  />
                  <div className="w-full h-fit flex flex-row mx-auto justify-center">
                    <span className="text-xl text-[black] ml-1">
                      Zip Awning
                    </span>
                  </div>
                  <div className="flex gap-5">
                    <img
                      className="object-center w-[2rem]"
                      alt="sun"
                      src={CFCDN + 'protecta/sun.png'}
                    />
                    <img
                      className="object-center w-[2rem]"
                      alt="cloud"
                      src={CFCDN + 'protecta/cloud.png'}
                    />
                    <img
                      className="object-center w-[2rem]"
                      alt="mosquito"
                      src={CFCDN + 'protecta/mosquito.png'}
                    />
                    <img
                      className="object-center w-[2rem]"
                      alt="wind"
                      src={CFCDN + 'protecta/wind.png'}
                    />
                  </div>
                  <span className="flex flex-row mx-auto text-lg text-center">
                    The Protecta Zip Awning offers the ultimate in all-weather
                    protection.
                  </span>
                  <button
                    className="transform text-white bg-black text-xl rounded-md  hover:text-black hover:bg-neutral-200 transition-transform duration-300 w-fit p-2 px-3 hover:-translate-y-1 border-none"
                    onClick={() => {
                      navigate('/protecta-zip-awning');
                    }}
                  >
                    More Info
                  </button>
                </div>

                <div className="w-[30rem] h-[40rem] flex flex-col gap-5 justify-center items-center p-2 rounded-md border border-solid border-neutral-200">
                  <img
                    className="w-[20rem] aspect-square object-cover mx-auto mt-3"
                    src={
                      CFCDN +
                      'protecta/Screenshot+2024-05-15+at+17-52-27+Protecta+Awning+Systems.png'
                    }
                    alt="Protecta Wire Guide Awning"
                  />
                  <div className="w-full h-fit flex flex-row mx-auto justify-center">
                    <span className="text-xl text-[black] ml-1">
                      Wire Guide Awning
                    </span>
                  </div>
                  <div className="flex gap-5">
                    <img
                      className="object-center w-[2rem]"
                      alt="sun"
                      src={CFCDN + 'protecta/sun.png'}
                    />
                    <img
                      className="object-center w-[2rem]"
                      alt="cloud"
                      src={CFCDN + 'protecta/cloud.png'}
                    />
                  </div>
                  <span className="flex flex-row mx-auto text-lg text-center">
                    Designed for large openings like patios and balconies, our
                    wire guide ensures security even in light breezes.
                  </span>
                  <button
                    className="transform text-white bg-black text-xl rounded-md  hover:text-black hover:bg-neutral-200 transition-transform duration-300 w-fit p-2 px-3 hover:-translate-y-1 border-none"
                    onClick={() => {
                      navigate('/protecta-wire-guide');
                    }}
                  >
                    More Info
                  </button>
                </div>

                <div className="w-[30rem] h-[40rem] flex flex-col gap-5 justify-center items-center p-2 rounded-md border border-solid border-neutral-200">
                  <img
                    className="w-[20rem] aspect-square object-cover mx-auto mt-3"
                    src="https://products-images-source.s3.ap-southeast-2.amazonaws.com/protecta/Screenshot+2024-05-15+at+17-53-18+Protecta+Awning+Systems.png"
                    alt="Protecta Straight Drop Awning"
                  />
                  <div className="w-full h-fit flex flex-row mx-auto justify-center">
                    <span className="text-xl text-[black] ml-1">
                      Straight Drop Awning
                    </span>
                  </div>
                  <div className="flex gap-5">
                    <img
                      className="object-center w-[2rem]"
                      alt="sun"
                      src={CFCDN + 'protecta/sun.png'}
                    />
                    <img
                      className="object-center w-[2rem]"
                      alt="cloud"
                      src={CFCDN + 'protecta/cloud.png'}
                    />
                  </div>
                  <span className="flex flex-row mx-auto text-lg text-center">
                    Suitable for use as an external screen in low wind areas.
                    This system is perfect for providing extra privacy & sun
                    protection where required.
                  </span>
                  <button
                    className="transform text-white bg-black text-xl rounded-md  hover:text-black hover:bg-neutral-200 transition-transform duration-300 w-fit p-2 px-3 hover:-translate-y-1 border-none"
                    onClick={() => {
                      navigate('/protecta-straight-drop');
                    }}
                  >
                    More Info
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={ref1}
          className={`transition-all ease-in duration-500 ${
            isVisible1 ? 'opacity-100' : 'opacity-0 translate-y-5'
          } relative flex flex-col justify-center items-center w-full max-w-screen-2xl rounded-md overflow-hidden h-[40vh] md:h-[50vh] `}
        >
          <div className="absolute bottom-0 h-full  w-full bg-black opacity-20"></div>
          <div className="absolute bottom-10  ml-5 left-0 w-fit  transform flex flex-col  px-2">
            <span className="text-white text-3xl lg:text-5xl xl:text-7xl hedvig-letters-serif-regular text-left">
              Protect Your Home <br></br>with our Roller Shutters
            </span>
            <button
              className="transform text-black bg-white text-xl rounded-md hover:bg-neutral-200 transition-transform duration-300 w-fit p-2 px-3 hover:-translate-y-1 border-none"
              onClick={() => {
                navigate('/products/roller-shutters');
              }}
            >
              Learn More
            </button>
          </div>

          <img
            src={
              'https://wpstaq-ap-southeast-2-media.s3.amazonaws.com/cwproducts/wp-content/uploads/media/2022/06/ASB2795-HI-387_42mmSingleLine_rev.webp'
            }
            alt="Centered Image"
            className={`object-center object-cover  w-full h-full`}
          />
        </div>

        <div className="flex flex-col   justify-between  gap-3   max-w-screen-2xl">
          <div className="w-full  h-full items-start gap-3">
            <div className="flex flex-col  m-auto items-center justify-center mt-10 mb-10">
              <span className="text-[2rem] md:text-[3.5rem] text-center  hedvig-letters-serif-regular">
                Top Picks for Your Windows
              </span>
              <div>
                <Divider style={{ width: '30px' }}></Divider>
              </div>
              <span className="hedvig-letters-sans-regular text-lg  text-center text-neutral-500">
                {
                  "Our customers' favorite selections, chosen for their exceptional style, functionality, and quality, are showcased here. These hand-selected window treatments are sure to enhance any space in your home."
                }
              </span>
            </div>
          </div>

          <div
            ref={ref3}
            className="w-full h-full  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 items-start gap-3"
          >
            {leftPanels.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`transition-all ease-in ${
                    isVisible3 ? 'opacity-100' : 'opacity-0 translate-y-3'
                  }`}
                  style={{ transitionDuration: getDisplayDelay(index) }}
                >
                  <ProductCard
                    key={index}
                    item={item}
                    index={index}
                    aspect="aspect-video"
                  ></ProductCard>
                </div>
              );
            })}
          </div>
        </div>

        <div className="flex flex-col  items-center justify-center w-full ">
          <span className="text-[2rem] md:text-[3.5rem] text-center hedvig-letters-serif-regular">
            Need help from our expert?
          </span>

          <span
            className="text-2xl text-center hedvig-letters-sans-regular underline transition-all duration-300 hover:translate-x-1 hover:text-neutral-500 mt-10 mb-10"
            onClick={() => {
              navigate('/contact');
            }}
          >
            Contact us
          </span>

          <PAQ></PAQ>
        </div>
      </Content>

      <ShopFrontFooter></ShopFrontFooter>
    </div>
  );
}
